export const View = 'view'
export const Icon = 'icon'
export const Progress = 'progress'
export const RichText = 'rich-text'
export const Text = 'text'
export const Button = 'button'
export const Checkbox = 'checkbox'
export const CheckboxGroup = 'checkbox-group'
export const Form = 'form'
export const Input = 'input'
export const Label = 'label'
export const Picker = 'picker'
export const PickerView = 'picker-view'
export const PickerViewColumn = 'picker-view-column'
export const Radio = 'radio'
export const RadioGroup = 'radio-group'
export const Slider = 'slider'
export const Switch = 'switch'
export const CoverImage = 'cover-image'
export const Textarea = 'textarea'
export const CoverView = 'cover-view'
export const MovableArea = 'movable-area'
export const MovableView = 'movable-view'
export const ScrollView = 'scroll-view'
export const Swiper = 'swiper'
export const SwiperItem = 'swiper-item'
export const Navigator = 'navigator'
export const Audio = 'audio'
export const Camera = 'camera'
export const Image = 'image'
export const LivePlayer = 'live-player'
export const Video = 'video'
export const Canvas = 'canvas'
export const Ad = 'ad'
export const WebView = 'web-view'
export const Block = 'block'
export const Map = 'map'
export const Slot = 'slot'
export const NativeSlot = 'native-slot'
export const CustomWrapper = 'custom-wrapper'
